enum FeatureFlags {
  DUAL_ENVIRONMENTS_FLAG = 'DUAL_ENVIRONMENTS_FLAG',
  DEEPSEEK_PLAYGROUND_LINK_ENABLED = 'DEEPSEEK_PLAYGROUND_LINK_ENABLED',
  MULTI_MODEL_PLAYGROUND_ENABLED = 'MULTI_MODEL_PLAYGROUND_ENABLED',
  ORG_NAV_BAR_2025 = 'ORG_NAV_BAR_2025',
  ORG_ENABLE_TRAINING = 'ORG_ENABLE_TRAINING',
  ORG_ENABLE_WEBSOCKET_GRPC_METRICS = 'ORG_ENABLE_WEBSOCKET_GRPC_METRICS',
  ORG_TRAINING_2025_08_GA_UI = 'ORG_TRAINING_2025_08_GA_UI',
  ORG_ENABLE_CUSTOM_METRICS = 'ORG_ENABLE_CUSTOM_METRICS',
  ORG_ENABLE_MODALITY_SPECIFIC_METRICS = 'ORG_ENABLE_MODALITY_SPECIFIC_METRICS',
  ORG_ENABLE_TEAMS_UI = 'ORG_ENABLE_TEAMS_UI',
  ORG_DYNAMIC_TARGET_UTILIZATION_PERCENTAGE_ENABLED = 'ORG_DYNAMIC_TARGET_UTILIZATION_PERCENTAGE_ENABLED',
  ORG_ENABLE_LOGS_SCROLLBAR = 'ORG_ENABLE_LOGS_SCROLLBAR',
  ORG_HIDE_BILLING_USAGE_COST_DETAILS = 'ORG_HIDE_BILLING_USAGE_COST_DETAILS',
  ORG_ENABLE_CHAIN_DEPLOYMENT_NAME = 'ORG_ENABLE_CHAIN_DEPLOYMENT_NAME',
  ORG_SUPPORT_ROLLING_DEPLOYS = 'ORG_SUPPORT_ROLLING_DEPLOYS',
}

export { FeatureFlags };
